import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {

    en: {
        translations: {
            "News": "News",
            "Classes": "Classes",
            "Multimedia": "Multimedia",
            "Layouts": "Layouts",
            "Log out": "Log out",
            "Username": "Username",
            "Password": "Password",
            "Recovery password?": "Recovery password?",
            "Login": "Login",
            "Email": "Email",
            "Recovery": "Revovery",
            "AÇORIANO ORIENTAL": "AÇORIANO ORIENTAL",
            "Multimedia New": "Multimedia New",
            "Gallery New": "Gallery New",
            "News to approve": "News to approve",
            "Scheduled news": "Scheduled news",
            "see all": "see all",
            "NEW": "NEW",
            "Add": "Add",
            "No articles pending": "No articles pending",
            "No articles scheduled": "No articles scheduled",
        }
    },
    pt: {
        translations: {
            "News": "Notícias",
            "Classes": "Turmas",
            "Class": "Turma",
            "Multimedia": "Multimédia",
            "Layouts": "Apresentação",
            "Log out": "Sair",
            "Username": "Utilizador",
            "Password": "Senha",
            "Recovery password?": "Esqueceu-se da palavra-passe?",
            "Login": "Entrar",
            "Email": "Email",
            "Recovery": "Recuperar",
            "AÇORIANO ORIENTAL": "AÇORIANO ORIENTAL",
            "Multimedia New": "Notícia Multimédia",
            "Gallery New": "Notícia Galeria",
            "News to approve": "Notícias por aprovar",
            "Scheduled news": "Notícias agendadas",
            "see all": "ver todas",
            "NEW": "NOVA",
            "New News": "Nova Notícia",
            "Approve News": "Aprovar Notícias",
            "Management News": "Gerir Notícias",
            "Add": "Adicionar",
            "Article Author": "Autor da Notícia",
            "New Multimedia News": "Nova Notícia Multimedia",
            "New Gallery News": "Nova Notícia Galeria",
            "Save draft": "Guardar Rascunho",
            "Save": "Guardar",
            "Create article": "Criar artigo",
            "Create draft": "Criar rascunho",
            "Cancel": "Cancelar",
            "Publish": "Publicar",
            "Unpublish": "Despublicar",
            "Go back": "Voltar atrás",
            "No articles pending": "Não existem artigos pendentes",
            "No articles scheduled": "Não existem artigos agendados",
            "Pre-Defined" : "Pré-Definido",
            "Unsaved changes": "Alterações por guardar",
            "Keep changes": "Manter alterações",
            "Discard changes": "Descartar alterações",
            "Featured Image": "Imagem de Destaque",
            "Status": "Estado",
            "Published" : "Publicado",
            "Unpublished": "Não publicado",
            "Strapline": "Ante título",
            "Title": "Título",
            "Lead": "Lead",
            "Body": "Corpo da notícia",
            "Layout": "Layout",
            "Select the layout": "Escolha o layout",
            "Schedule article": "Agendar Notícia",
            "Write the name": "Escreva o nome",
            "Do you wish to remove this article?" : "Deseja remover este artigo?",
            "Do you wish to unpublish this article?" : "Deseja despublicar este artigo?",
            "Do you wish to publish this article?" : "Deseja publicar este artigo?",
            "Submission": "Submissão",
            "Actions": "Ações",
            "No articles": "Não existem artigos",
            "User": "Utilizador",
            "Description": "Descrição",
            "Edit Class" : "Editar Turma",
            "No registered classes" : "Ainda não existem turmas registadas.",
            "Add a new class using the form at your right" : "Adicione uma turma utilizando o formulário à direita.",
            "Add Files": "Adicionar Ficheiros",
            "Files": "Ficheiros",
            "Upload Files": "Carregar Ficheiros",
            "Update File": "Atualizar Ficheiro",
            "Remove File": "Remover Ficheiro",
            "Add File": "Adicionar Ficheiro",
            "Edit File": "Editar Ficheiro",
            "Select Articles" : "Selecionar Artigos",
            "Conclude Selection": "Concluir Seleção",
            "File Name": "Nome do ficheiro",
            "File Author": "Autor do ficheiro",
            "Select Image": "Selecionar Imagem",
            "Upload Image": "Carregar Imagem",
            "Images": "Imagens",
            "Add Image": "Adicionar Imagem",
            "Remove Class": "Remover Turma",
            "Remove": "Remover",
            "Author rights": "Direitos de autor",
            "Yes, I do": "Sim, tenho",
            "Search": "Pesquisar",
            "Submit": "Submeter",
            "Approve": "Aprovar",
            "Selected Image": "Imagem Selecionada",
            "File" : "Ficheiro",
            "Select Files" : "Selecionar Ficheiros",
            "Author" : "Autor",
            "No" : "Não",
        }
    },

};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'pt',
        fallbackLng: 'pt',
        whitelist: ['en', 'pt'],
        keySeparator: false, // we do not use keys in form messages.welcome
        debug: false,
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        react: {
            wait: true,
        },
    });

export default i18n;
